import { render, staticRenderFns } from "./previous_debts.vue?vue&type=template&id=1a8543c4&scoped=true&"
import script from "./previous_debts.vue?vue&type=script&lang=js&"
export * from "./previous_debts.vue?vue&type=script&lang=js&"
import style0 from "./previous_debts.vue?vue&type=style&index=0&id=1a8543c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8543c4",
  null
  
)

export default component.exports